import { configureStore } from "@reduxjs/toolkit";
import { setupListeners } from "@reduxjs/toolkit/query";
import { shoeApi } from "./services";

import selectedSlice from "./reducers/selectedSlice";
import authSlice from "./reducers/auth";

export const store = configureStore({
  reducer: {
    selected: selectedSlice,
    auth: authSlice,
    [shoeApi.reducerPath]: shoeApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(shoeApi.middleware),
});

setupListeners(store.dispatch);

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
